import { CombinedDownload } from '@goldcast/api/content';
import { useMemo, useSyncExternalStore } from 'react';
import ClipDownloadPopup from './ClipDownloadPopup';
import PostDownloadPopup from './PostDownloadPopup';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { core } from '@/stores/core';
import type { TextAsset } from '@/Pages/PostsListPage/types';

interface DownloadsPopupV2Props {
  loading: boolean;
  processingDownloads: CombinedDownload[];
  recentDownloads: CombinedDownload[];
  selectedPost?: TextAsset | null;
}

export default function DownloadsPopupV2({
  loading,
  processingDownloads,
  recentDownloads,
  selectedPost
}: Readonly<DownloadsPopupV2Props>) {
  const { clipData } = useClipsContext();
  const coreStore = useSyncExternalStore(core.subscribe, core.getSnapshot);

  const isOnClipsPage = useMemo(() => {
    return !!clipData?.id && !!clipData?.asset_metadata;
  }, [clipData]);

  const isOnTextAssetPage = useMemo(() => {
    const hasContent = !!coreStore.content?.id || !!selectedPost?.content?.id;
    return hasContent && !!selectedPost && !isOnClipsPage;
  }, [coreStore.content, selectedPost, isOnClipsPage]);

  if (isOnClipsPage) {
    return (
      <ClipDownloadPopup
        loading={loading}
        processingDownloads={processingDownloads}
        recentDownloads={recentDownloads}
      />
    );
  }

  if (isOnTextAssetPage) {
    return (
      <PostDownloadPopup
        loading={loading}
        processingDownloads={processingDownloads}
        recentDownloads={recentDownloads}
        selectedPost={selectedPost}
      />
    );
  }

  return null;
}
